'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationContext = undefined;

var _SimpleSchema = require('./SimpleSchema');

require('./clean.js');

exports.default = _SimpleSchema.SimpleSchema;
exports.ValidationContext = _SimpleSchema.ValidationContext;


//////////////////
// WEBPACK FOOTER
// ../~/simpl-schema/dist/main.js
// module id = 605
// module chunks = 0